import { Injectable } from '@angular/core';
import { Route } from '@angular/router';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { IPageHeader } from '../../interfaces/pageHeader.interface';
import * as fromLayoutActions from './aumico.layout.action';
import { INavigationEvent } from './aumico.layout.action';
import { IAumicoCoreLayoutProvider } from './aumico.layout.provider.interface';
import * as fromLayoutReducer from './aumico.layout.reducer';

@Injectable({
    providedIn: 'root',
})
export class AumicoCoreLayoutProvider implements IAumicoCoreLayoutProvider {
    constructor(public store: Store<fromLayoutReducer.ModuleState>) {}
    /**
     *
     * @deprecated use dispatchNavigateToRoute instead
     */
    public dispatchShouldNavigateToRoute(event: INavigationEvent): void {
        this.dispatchNavigateToRoute(event);
    }

    public dispatchNavigateToRoute(event: INavigationEvent): void {
        this.store.dispatch(fromLayoutActions.onShouldNavigateToRoute({ payload: event }));
    }

    public triggerOnSubNavigation(event: INavigationEvent): void {
        this.store.dispatch(fromLayoutActions.onSubNavigation({ payload: event }));
    }

    public dispatchUpdateHideFooterOption(hideOptions: boolean): void {
        this.store.dispatch(fromLayoutActions.updateHideFooterOption({ payload: hideOptions }));
    }

    public getHideFooterOption$(): Observable<boolean> {
        return this.store.select(fromLayoutReducer.selectHideFooterOption);
    }

    public getActiveSubNavigation(): Observable<Route> {
        return this.store.select(fromLayoutReducer.selectActiveSubNavigation);
    }

    public getActivePage(): Observable<Route> {
        return this.store.select(fromLayoutReducer.selectActivePage);
    }
    public dispatchSetLayoutHidden(isHidden: boolean): void {
        this.store.dispatch(fromLayoutActions.updateLayoutIsHidden({ payload: isHidden }));
    }
    public getIsLayoutHidden$(): Observable<boolean> {
        return this.store.select(fromLayoutReducer.selectLayoutIsHidden);
    }

    public resetLayout(): void {
        this.store.dispatch(fromLayoutActions.resetLayout());
    }

    public getPageHeader$(): Observable<IPageHeader> {
        return this.store.select(fromLayoutReducer.selectPageHeader);
    }

    public dispatchChangePageHeader(pageHeader: IPageHeader): void {
        this.store.dispatch(fromLayoutActions.changePageHeader({ payload: pageHeader }));
    }
}
